import React from 'react'
import { Observable } from 'rx'
import { ConfirmBetSucceeded, ConfirmMultiBetSucceeded } from '@core/Areas/Quickbet/signals'
import { triggerHapticFeedback } from '@core/Utils/hapticFeedback/hapticFeedback'

export const useHapticFeedbackOnBetSuccess = () => {
  React.useEffect(() => {
    const subscription = Observable.merge(
      ConfirmBetSucceeded.signal$,
      ConfirmMultiBetSucceeded.signal$
    ).subscribe(() => {
      triggerHapticFeedback('success')
    })
    return () => subscription.dispose()
  }, [])
}
